export enum ChannelNameSpace {
  player = 'player', // 播放器
  engine = 'engine', // 互动引擎
  bridge = 'bridge', // bridgeHelper
}

export enum CompsNameSpace {
  worker = 'worker',   // worker
  tracker = 'tracker', // tracker
  utils = 'utils',     // utils
}

export interface ChannelMessage {
  nodeId: string;
  ns: ChannelNameSpace | CompsNameSpace;
  method: string;
  data: any;
  seq?: string;
  // invoke promise error
  // 组件中可以通过 try catch 捕获到类似于断网的错误
  type?: 'reject';
  isEnd?: boolean;
}

export interface IParentBridge {
  init?: Function;
  ready?: Function;
  send(data: ChannelMessage): void;
  show(): void;
  hide(): void;
  destroy(): void;
}

export interface IChannel {
  containerId: string;
  iframeSrc: string;
  init: Function;
  useWorker?: boolean;
}
